/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Text } from 'native-base';

import { IHeaderProps } from './types';

export const Header = ({ ...props }: IHeaderProps) => <Text {...props} />;
